"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCashBackCustomIcon = exports.CashBackCustomIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _Image = _interopRequireDefault(require("../../../Image"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
;
var SIZES = {
  s: {
    width: 11,
    height: 12
  },
  m: {
    width: 12,
    height: 14
  },
  l: {
    width: 16,
    height: 20
  }
};
var CashBackCustomIcon = exports.CashBackCustomIcon = function CashBackCustomIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    cashbackIconWebp = _ref.cashbackIconWebp,
    cashbackIconPng = _ref.cashbackIconPng;
  return /*#__PURE__*/_react["default"].createElement(StyledCashBackCustomIcon, {
    alt: "cashback icon",
    src: cashbackIconWebp,
    fallback: cashbackIconPng,
    size: size
  });
};
var StyledCashBackCustomIcon = exports.StyledCashBackCustomIcon = (0, _styledComponents["default"])(_Image["default"]).withConfig({
  displayName: "CashbackCustomIcon__StyledCashBackCustomIcon",
  componentId: "sc-c4et7k-0"
})(["display:block;width:", "px;height:", "px;"], function (_ref2) {
  var size = _ref2.size;
  return SIZES[size].width;
}, function (_ref3) {
  var size = _ref3.size;
  return SIZES[size].height;
});